<template>
  <div class="dd-about">
    <Header/>
    <Banner :image="bannerImage" title="关于我们" description="让我们一起创造更多可能"/>
    <Section title="关于数鸽">
      <div class="clearfix">
        <div class="dd-about__left">
        </div>
        <div class="dd-about__right">
          <p>金十数据是国内财经领域领先的数据服务商，其业务包括给投资者提供数 据资讯，行情工具，在线培训等。数鸽·数据可视化是金十数据依托于抖音、 快手等短视频平台发展而来新业务，它以直观的视频形式来展现各方面数据， 深受用户喜爱。</p>
          <p>
          视频数据可视化可以通过三维建模，摄像机视角变化，数据在 立体空间的强烈对比，以及音乐氛围的烘托来“制造”令人印象深刻的数据， 展现数据的魅力。</p>
          <p>金十数据有近 50 人的视频制作团队，并国内首创了视频数据 可视化，可以为政府、企业、媒体定制视频，展现其想表达的内容。目前我们 已经为央视新闻，央视网，国家统计局，人民网，新华社等制作了多期视频， 并建立了长期合作。目前金十数据(至 2019 年 5 月 8 日)在抖音有 352.1 万粉丝，快手有 85.2 万粉丝。</p>
        </div>
      </div>
    </Section>
    <Footer/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerImage: require('../assets/about.jpg')
    }
  }
}
</script>

<style lang="scss">
.dd-about {
  &__left {
    float: left;
    width: 390px;
    height: 531px;
    background: #555 url("~@/assets/about_left.png") center no-repeat;
    background-size: cover;
  }
  &__right {
    padding-left: 120px;
    line-height: 34px;
    overflow: hidden;

    &:after {
      content: "";
      display: block;
      width:180px;
      height:4px;
      background:rgba(204,204,204,1);
    }
    p {
      margin: 2.5em 0;
    }
  }
  @include media-tablet {
    &__left {
      display: none;
    }
    &__right {
      padding-left: 0;

      &:after {
        height: 2px;
      }
    }
  }
}
</style>
